import Vue from 'vue'

Vue.filter('pluralize', (text, count) => (count === 1 ? text : `${text}s`))
